import React from "react";
import { ContentSection, GridRow, GridColumn, LabeledText, CodedProperty, ButtonRenderProps } from "sprint-common-web";

import { getLanguageDisplayName } from "../../../../../../../common/types/Language";
import {
    EditCloudAudioAssetButtonAside,
    EditCloudAudioAssetButtonAsideProps
} from "./edit/EditCloudAudioAssetButtonAside";

interface CloudAudioLanguageSectionProps {
    isLoading: boolean;
    language: CodedProperty;
}

export const CloudAudioLanguagesSection: React.FunctionComponent<CloudAudioLanguageSectionProps> = (
    props: CloudAudioLanguageSectionProps
) => {
    const { isLoading, language } = props;

    const editSoundtrackButton: ButtonRenderProps<EditCloudAudioAssetButtonAsideProps> = {
        isLabeled: true,
        render: EditCloudAudioAssetButtonAside,
        soundtrackId: language.id
    };

    return (
        <ContentSection header="Languages" isLoading={isLoading} buttons={[editSoundtrackButton]}>
            <GridRow style={{ height: 200 }}>
                <GridColumn sm={12}>
                    <LabeledText
                        label="Soundtracks"
                        value={getLanguageDisplayName(language)}
                        testId="soundtracks-field"
                    />
                </GridColumn>
            </GridRow>
        </ContentSection>
    );
};
